import { apiClient } from './client'
import endpoints from './endpoints'

// The endpoint runs the clustering (STRATAS + write) in the background and answers 202 with the
// created run as its body; the client tracks that run through the clusters read
// (meta.latestRun) instead, so the response is never unwrapped or read here.
export default async function createFarmClusters({ farmId }: { farmId: string }): Promise<void> {
  await apiClient.post(endpoints.v2.farms.clusters(farmId), {})
}
